<template>
    <div>
        <v-select dir="rtl" label="title" @option:selected="selectUser" :placeholder="txtPlaceholder" :filterable="UserList.length>10" :searchable="UserList.length>10" :options="UserList" :reduce="p => p.userId" v-model="userId">
            <template slot="option">
                <div class="d-center">
                    {{ option.title }}
                </div>
            </template>
        </v-select>
    </div>
</template>
<script>

    export default {
        props: ['txtPlaceholder'],
        data() {
            return {
                placeholder: this.txtPlaceholder,
                userFilterText: "",
                userId: null
            }
        },
        watch: {
            'userId'(value) {
                if (!value) {
                    this.userId = null;
                    this.$emit('selectUser', this.userId);
                }
            }
        },
        computed: {
            UserList() {
                let list = this.$store.getters.GetLocalUserListList;
                return list;
            },
        },
        methods: {
            onSearchUsers(search) {
                if (search.length >= 2) {
                    this.userFilterText = search;
                    this.GetUsersList();
                }
                if (search == null || search == '') {
                    this.userFilterText = "";
                    this.GetUsersList();
                }
            },
            selectUser(d) {
                this.userId = d.userId;
                this.$emit('selectUser', this.userId);
            },
            GetUsersList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    workGroupId: null
                });
            }
        },
        created() {
            this.GetUsersList();
        }
    }
</script>
